import { DropIcon, InfoIcon, Mtds, QrCodeIcon } from 'prove-common'

type SampleInfoCardProps = {
  sampleId?: string
  matrix?: string
  description?: string
}

export const SampleInfoCard = ({
  sampleId,
  matrix,
  description
}: SampleInfoCardProps) => {
  return (
    <Mtds.Card as={Mtds.Grid} data-gap={5}>
      <Mtds.Heading as='h3'>Informasjon om prøven</Mtds.Heading>
      <Mtds.Info>
        <QrCodeIcon />
        <strong>Kode</strong> {sampleId}
      </Mtds.Info>

      <Mtds.Info>
        <DropIcon />
        <strong>Prøve av</strong> {matrix}
      </Mtds.Info>

      <Mtds.Info>
        <InfoIcon />
        <strong>Beskrivelse</strong>{' '}
        {description != null && description.length > 0
          ? description
          : 'Ingen beskrivelse'}
      </Mtds.Info>
    </Mtds.Card>
  )
}
